import { Investimento } from './../../domain/primecap/model/investimento';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TipoColunaEnum } from 'src/app/shared/tabela-crud/model/tipo-coluna.enum';
import { AcoesCrudEnum } from './tabela-acoes.enum';
import { EventoAcaoCrud, EventoAcaoExtra, EventoFiltro, EventoInvestimento, EventoTrocaStatus } from './model/tabela-eventos.model';
import { Paginacao } from './tabela-paginacao';
import { IColumModel } from './model/IColum.model';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-tabela-crud',
  templateUrl: './tabela-crud.component.html',
  styleUrls: ['./tabela-crud.component.css']
})
export class TabelaCrudComponent implements OnChanges {

  // par chave-valor, onde o valor é o nome da coluna que ficará visível na tabela
  // e a chave é a referência da coluna dentro da tabela, devendo indicar o caminho do
  // atributo dentro do objeto que será tabelado
  @Input() definicaoColuna: IColumModel[] = [];

  // array com os dados a serem exibidos
  @Input() dadosTabela: any[];

  // quando true lista os dados paginados na API
  @Input() habilitarPaginacaoNoBackend?= false;

  // quando true pesquisa dados na API
  @Input() habilitarBuscaNoBackend? = false;

  // guarda o valor a ser buscado na API
  form?: FormGroup;

  // do tipo any pois o tipo de dados é definido em tempo de execução no componente pai
  dataSource: MatTableDataSource<any>;

  paginaConfig: PageEvent = Paginacao.paginaConfig();
  @Input() definicaoConfigPagina: PageEvent;

  // definição da quantidade de itens por página
  tamanhoPaginaPadrao: number[] = Paginacao.tamanhoPaginaPadrao;

  // pode modificar quantidade de itens por página a partir do componente pai
  @Input() definicaoTamanhoPagina?: number[] = [];

  // propriedade usada no HTML representando as ações CRUD
  readonly acoesCrud: typeof AcoesCrudEnum = AcoesCrudEnum;

  // exibe a barra de pesquisa
  @Input() exibirBusca?: boolean = true;

  // exibe checkboxes para filtros
  @Input() exibirFiltros?: boolean = false;

  // exibe o nome da coluna
  @Input() exibirNomeColuna?: boolean = true;

  // exibe o nome da coluna
  @Input() exibirMatSort?: boolean = true;

  // exibe o paginador
  @Input() exibirPaginador?: boolean = true;

  // colunas com ações a serem exibidas
  @Input() exibirColunaCrud?: boolean = false;
  @Input() exibirColunaStatuses?: boolean = false;
  @Input() exibirColunaArquivo?: boolean = false;

  // ações crud a serem exibidas na tabela
  @Input() exibirCriacao?: boolean = false;
  @Input() exibirEdicao?: boolean = false;
  @Input() exibirDelecao?: boolean = false;
  @Input() exibirDetalhes?: boolean = false;

  // outras ações a serem exibidas na tabela
  @Input() exibirDashboard?: boolean = false;
  @Input() exibirAbrirPagina?: boolean = false;
  @Input() exibirAtivacao?: boolean = false;
  @Input() exibirDesativacao?: boolean = false;
  @Input() exibirAssinarInvestimento?: boolean = false;
  @Input() exibirConfirmarPagamento?: boolean = false;
  @Input() exibirRecusarInvestimento?: boolean = false;
  @Input() exibirAnalisarInvestimento?: boolean = false;
  @Input() exibirEnviarBoleto?: boolean = false;

  // indica que se trata de uma rodada de investimento
  // para exibir botão de edição somente quando status == 'STAND_BY'
  @Input() isRodadaInvestimento?: boolean = false;

  @Input() tituloAbrirPagina?: string = 'Visualizar';
  @Input() iconeAbrirPagina?: string = 'open';

  @Input() isAssessor: boolean = false;

  // notifica o componente pai qual operação crud e objeto foram chamados
  @Output() readonly acaoCrud: EventEmitter<EventoAcaoCrud<any>> = new EventEmitter();

  // notifica o componente pai qual ação e objeto foram chamados
  @Output() readonly acaoExtra: EventEmitter<EventoAcaoExtra<any>> = new EventEmitter();

  // notifica o componente pai de uma mudança no status da rodada de investimento
  @Output() readonly trocaStatus: EventEmitter<EventoTrocaStatus<any>> = new EventEmitter();

  // notifica o componente pai de que uma ação em um investimento foi chamada
  @Output() readonly acaoInvestimento: EventEmitter<EventoInvestimento> = new EventEmitter();

  // notifica o componente pai se a página foi passada
  @Output() readonly paginacao: EventEmitter<PageEvent> = new EventEmitter();
  @Output() readonly paginacaoFiltrada: EventEmitter<EventoFiltro<any>> = new EventEmitter();

  // notifica o componente pai de que uma busca está sendo feita na tabela
  @Output() readonly pesquisa: EventEmitter<EventoFiltro<any>> = new EventEmitter();

  // @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  valorBuscado: any;

  constructor(
    private formBuilder: FormBuilder
  ) {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // definição da coluna de download de arquivo
    if (this.exibirColunaArquivo && !this.definicaoColuna.some((d: any) => d.tipo === TipoColunaEnum.Arquivo)) {
      this.definicaoColuna.push({prop: 'arquivo', nome: 'Arquivo', tipo: TipoColunaEnum.Arquivo});
    }

    // definição da coluna de status
    // para modificar o status da rodada de investimento
    if (this.exibirColunaStatuses && !this.definicaoColuna.some((d: any) => d.tipo === TipoColunaEnum.Statuses)) {
      this.definicaoColuna.push({prop: 'statuses', nome: 'Status', tipo: TipoColunaEnum.Statuses});
    }

    // definição da coluna de ações CRUD
    if (this.exibirColunaCrud && !this.definicaoColuna.some((d: any) => d.tipo === TipoColunaEnum.Acoes)) {
        this.definicaoColuna.push({prop: 'acoes', nome: 'Ações', tipo: TipoColunaEnum.Acoes});
    }

    this.dataSource.data = this.dadosTabela || [];
    this.dataSource.sort = this.sort;

    // torna o sorting da tabela case insensitive
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId) => {
      if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }
      return data[sortHeaderId];
    };

    if (!this.habilitarPaginacaoNoBackend) {
      this.dataSource.paginator = this.paginator;
    } else {
      this.form = this.formBuilder.group({
        filtro: null
      });
    }

    // substitui a quantidade de itens por página
    // caso solicitado no componente pai
    if (changes.definicaoTamanhoPagina) {
      this.tamanhoPaginaPadrao = this.definicaoTamanhoPagina;
    }

    if (changes.definicaoConfigPagina) {
      this.paginaConfig = this.definicaoConfigPagina;
    }
  }

  // aplica a busca dentro da tabela
  aplicarFiltroDeBusca(evento: any) {
    if (this.habilitarBuscaNoBackend) {
      this.valorBuscado = this.form.get('filtro').value.trim().toLowerCase();
      this.pesquisa.emit({valorBuscado: this.valorBuscado, pageEvent: this.paginaConfig});
    } else {
      this.valorBuscado = evento.target.value.trim().toLowerCase();
      this.dataSource.filter = this.valorBuscado;
    }
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  limparFiltro() {
    this.form.reset();
    this.valorBuscado = '';
    this.pesquisa.emit({valorBuscado: '', pageEvent: this.paginaConfig});
  }

  // aplica a paginação na tabela
  mudarPagina(pageEvent: PageEvent) {
    if (!pageEvent || !this.paginacao) {
      return;
    }

    if (this.valorBuscado != '' && this.valorBuscado != undefined) {
      this.paginacaoFiltrada.emit({valorBuscado: this.valorBuscado, pageEvent: pageEvent});
    } else {
      this.paginacao.emit(pageEvent);
    }
  }

  // emite evento de notificação de que uma operação crud foi solicitada
  // em um objeto
  executarAcaoCrud(acaoCrud: string, objeto: any): void {
    if (!this.acaoCrud) {
      return;
    }
    this.acaoCrud.emit({ acaoCrud, objeto });
  }

  // emite evento de notificação de que uma ação foi solicitada
  // em um objeto
  executarAcaoExtra(acaoExtra: string, objeto: any): void {
    if (!this.acaoExtra) {
      return;
    }
    this.acaoExtra.emit({ acaoExtra, objeto });
  }

  // emite evento de notificação de que o status da rodada de
  // investimento será trocado
  executarTrocaDeStatus(novoStatus: string, objeto: any): void {
    if (!this.trocaStatus) {
      return;
    }
    this.trocaStatus.emit({ novoStatus, objeto });
  }

  // emite evento de notificação de que uma ação foi solicitada
  // em um investimento
  executarAcaoInvestimento(acaoInvestimento: string, investimento: Investimento): void {
    if (!this.acaoInvestimento) {
      return;
    }
    this.acaoInvestimento.emit({ acaoInvestimento, investimento });
  }

  getProperty = (obj: any, path: any) => (
    path.split('.').reduce((o: any, p: any) => o && o[p], obj)
  )

  get columnsProp() {
    return this.definicaoColuna.map((d: any) => d.prop);
  }

  get TipoColuna() {
    return TipoColunaEnum;
  }
}
